<div class="input-group">
	<input [id]="id" [name]="id"
		class="form-control"
		matInput
		[matDatepicker]="picker"
		[disabled]="disabled"
		[min]="minDate"
		[max]="maxDate"
		[value]="date"
		(dateChange)="onDateChange($event)"
		/>
	<mat-datepicker #picker></mat-datepicker>
	<div class="input-group-addon datepicker-addon">
		<mat-datepicker-toggle matSuffix [for]="picker" [disableRipple]="true" [disabled]="disabled">
			<i matDatepickerToggleIcon class="fa fa-calendar"></i>
		</mat-datepicker-toggle>
	</div>
</div>
